<div class="relative flex flex-col min-h-screen">
  <!-- header -->
  <app-header class="md:sticky md:top-0 z-1030" />
  <!-- run 24: drawn only while a search runs on a page that placed no line of its own -->
  <app-search-line-loader fallback />
  <router-outlet />
</div>
